import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  createRef,
  useEffect,
} from "react";

import "../ficha-master.css";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import FormInput from "../../../../nuup/componentes/Forms/FormInput.jsx";
import Api from "../../../../api/global.service.js";
import BlockUi from "react-block-ui";
import LinkDownload from "../../../../components/link/link-download.jsx";
import env from "../../../../environment.js";

import ModalFichaMasterActualizaDatos from "../modals/modal-ficha-master-actualiza-datos.jsx";
import ModalFichaCoopActualizaForm from "../modals/modal-ficha-coop-actualiza-form.jsx";

const FichaCoopItem = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);

  const [blocking, setBlocking] = useState(false);
  const [infoKobo, setInfoKobo] = useState({});
  const [statusForm, setStatusForm] = useState("status-form-error");
  const [estatusCsv, setEstatusCsv] = useState(false);

  const dialog = createRef();
  const dialog2 = createRef();

  useEffect(() => {
    if (props.infoKobo && Object.keys(props.infoKobo).length > 0) {
      setInfoKobo(props.infoKobo);
    }
  }, [props.infoKobo]);

  useEffect(() => {
    setEstatusForm();
  }, [infoKobo]);

  const setEstatusForm = async () => {

    if (infoKobo?.deployed_version_id === null) {
      setStatusForm("status-form-error");
    } else {
      if (infoKobo?.version_id != infoKobo?.deployed_version_id) {
        setStatusForm("status-form-warning");
      } else {
        setStatusForm("status-form-ok");

      }
    }


  };


  const getEstatus = () => {
    if (infoKobo?.has_deployment) {
      if (infoKobo?.deployment__active) {
        return "Implementado";
      } else {
        return "Archivado";
      }
    } else {
      return "Borrador";
    }
  }


  const actualizaMedia = (id_kobo_ficha_principal) => {
    setEstatusCsv(true);
    Api.getAll(`ficha/kobo/coop/actualizaMedia/${id_kobo_ficha_principal}`)
      .then((response) => {
        if (response.data.status === 'success') {
          Swal.fire({
            title: '¡Actualización exitosa!',
            text: 'Los archivos han sido actualizados correctamente.',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          });
        }
        setEstatusCsv(false);
      })
      .catch((e) => {
        setEstatusCsv(false);
        Swal.fire({
          title: '¡Error!',
          text: 'Ocurrió un error al actualizar los archivos.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      });

  }

  return (
    <div
      key={props?.data?.id_kobo_ficha_principal}
      className={"row ficha-master-item " + statusForm}
    >
      <div className="col-xl-1">
        <div className="ficha-coop-image">
          {props?.data?.cooperativa?.logo ? (
            <img
              src={`${env.assetURL}${props.data.cooperativa.logo}`}
              alt={props?.data?.cooperativa?.nombre}
              className="ficha-coop-image__img"
            />
          ) : (
            <div className="ficha-coop-image__placeholder">
              <i className="fa fa-building"></i>
            </div>
          )}
        </div>
      </div>
      <div className="col-xl-4">

        <p>
          ID:{" "}
          <span className="item-desc">
            {props?.data?.id_kobo_ficha_principal}
          </span>
        </p>
        <p>
          Nombre: <span className="item-desc">{props?.data?.nombre}</span>
        </p>
        <p>
          Descripción:{" "}
          <span className="item-desc">{props?.data?.descripcion}</span>
        </p>

        <p>
          Cooperativa:{" "}
          <span className="item-desc">{props?.data?.cooperativa?.nombre}</span>
        </p>
        <p>
          Ciclo: <span className="item-desc">{props?.data?.ciclo?.nombre}</span>
        </p>
        <p>
          Cultivo:{" "}
          <span className="item-desc">{props?.data?.cultivo?.nombre}</span>
        </p>
      </div>

      <div className="col-xl-4">
        <p>
          Estatus:{" "}
          <span className="item-desc">{getEstatus()}</span>
        </p>

        <p>
          Número de preguntas:{" "}
          <span className="item-desc">{infoKobo?.summary?.row_count || 0}</span>
        </p>

        <p>
          Número de registros:{" "}
          <span className="item-desc">{infoKobo?.deployment__submission_count || 0}</span>
        </p>


        <p>
          Propietario:{" "}
          <span className="item-desc">{infoKobo?.owner__username}</span>
        </p>

        <p>
          Permisos:{" "}
          <span className="item-desc">{infoKobo?.users?.join(", ")}</span>
        </p>

        <p>
          <a style={{ color: "gray" }} target="_blank" href={infoKobo?.koboUrl}><i className="fa fa-link"></i> Ver en Kobo</a>
        </p>

      </div>


      <div className="col-xl-3">
        <div className="botones-ficha">
          <button
            onClick={() => {
              dialog.current.setData(props?.data);
              dialog.current.setDataMaster(props?.fichaMaster);
              dialog.current.show();
            }}
            className="btn btn-success btn-action"
          >
            <i className="fa fa-edit"></i>
            <span>Actualizar datos</span>
          </button>

          <button
            onClick={() => {
              dialog2.current.setData(props?.data);
              dialog2.current.setDataMaster(props?.fichaMaster);
              dialog2.current.show();
            }}
            className="btn btn-sirio btn-action"
          >
            <i className="fas fa-file-upload"></i>
            <span>{((infoKobo?.summary?.row_count) ? "Actualizar" : "Cargar") + " formulario"}</span>
          </button>
          {props?.data?.archivo && props?.data?.archivo.length > 0 && (
            <div className="btn btn-sirio btn-action">
              <LinkDownload
                url={`ficha/kobo/coop/descarga/${props?.data?.id_kobo_ficha_principal}`}
                label="Descargar ficha"
                icon={env.images.icon.xls}
                color={"#000"}
              />
            </div>
          )}

          {props?.data?.archivo && props?.data?.archivo.length > 0 && (

            <button
              onClick={() => actualizaMedia(props?.data?.id_kobo_ficha_principal)}
              className="btn btn-success btn-action btn-dark"
              disabled={blocking || estatusCsv}
            >
              <i style={{ color: 'white' }} className="fa fa-file"></i>
              <span style={{ color: 'white', paddingLeft: 5 }}>{(estatusCsv) ? 'Actualizando...' : 'Actualizar CSVs'}</span>
            </button>
          )}

        </div>
      </div>
      <ModalFichaMasterActualizaDatos
        ref={dialog}
        title="Actualiza datos"
        onFinish={() => {
          props.onModalClose();
        }}
      />
      <ModalFichaCoopActualizaForm
        ref={dialog2}
        title="Actualiza ficha"
        onFinish={() => {
          props.onModalClose();
        }}
      />
    </div>
  );
});

export default FichaCoopItem;
